<template>
   <mw-dialog :title="$lang('编辑常用意见')" :appendToBody="false" size="small_small" ref="dialog" :footerButton="sugButton">
     <div class="mw-toolbar">
        <el-button @click="addOpinion" size="mini" type="primary"><i class=" fa fa-plus-square"></i>{{$lang("添加")}}</el-button>
        <span style="float: right;padding-right: 20px;">{{$lang("备注：意见拖动排序")}}</span>
    </div>

    <div class="mw-toolbar__body">
         <el-table
            class="mw-table mw-edit-comment"
            ref="multipleTable"
            :data="comment"
            :show-header="false"
            style="cursor: pointer">

            <el-table-column prop="title" width="450" :label="$lang('意见')">

            </el-table-column>

            <el-table-column>
              <template slot-scope="scope">
                <el-button icon="el-icon-delete" size="small" @click="handleDelete(scope.$index, scope.row)">{{$lang("删除")}}</el-button>
                <el-button icon="el-icon-edit" size="small" @click="editOpinion(scope.$index, scope.row)">{{$lang("编辑")}}</el-button>
              </template>
            </el-table-column>
         </el-table>
    </div>
   </mw-dialog>

</template>
<script>

  export default {
    props:{
      params:{
        type: Object
      }
    },

    data() {
      let me = this;
      return {
         comment: [],
         enableSortable:false,
         sugButton:[{
            label: $lang('确定'),
            func: this.editCommentSure
         },{
           label: $lang('取消'),
           type: 'default',
           func: this.closeDialog
         }
         ]
      }
    },

    mounted(){
      let me = this;
      setTimeout(()=>{
        this.show();
        this.$nextTick(function () {
          me.$refs.multipleTable.$nextTick(function () {
            me.sortable();
          })
        })
      },200)
      this.comment = this.params.comment;
    },
    methods: {
      show(){
        this.mwRef('dialog').show();
      },
      editCommentSure(){
        this.params.func(this.comment);
        this.closeDialog();
      },
      closeDialog(){
        this.mwRef('dialog').hide();
      },
      addOpinion(){
        this.$prompt('', $lang('添加常用意见'), {
            confirmButtonText: $lang('确定'),
            cancelButtonText: $lang('取消'),
            inputType:"textarea",
            inputPattern:/\S+/,
            inputPlaceholder:$lang("请输入意见"),
            inputErrorMessage:$lang("请输入意见")
          }).then(({ value }) => {
            this.comment.push({title : value});
          }).catch(() => {

          });
      },

      editOpinion(index,row){
        this.$prompt('', $lang('编辑常用意见'), {
            confirmButtonText: $lang('确定'),
            cancelButtonText: $lang('取消'),
            inputType:"textarea",
            inputPattern:/\S+/,
            inputPlaceholder:$lang("请输入意见"),
            inputErrorMessage:$lang("请输入意见"),
            inputValue: row.title
          }).then(({ value }) => {
            this.comment[index].title = value;
          }).catch(() => {
          });
      },
      handleDelete(index,row){
        this.comment.splice(index,1);
      },
      $lang(key,defaultValue){
        return $lang(key,defaultValue);
      },
      getSortableEl() {
        return $(this.$el).find(".el-table__body-wrapper tbody");
      },
      sortable() {
        let me=this;
        me.enableSortable=true; //直接调用方法的时候。设置标识。
        let el=this.getSortableEl();
        let dragStart=-1;
        let dragEnd=-1;
        el.sortable({
          start:function(event,ui){
            let item=ui.item;
            dragStart=item.index();
          },
          update:function(event,ui){
            let item=ui.item;
            dragEnd=item.index();
            el.sortable("cancel");
            updateDataList(dragStart, dragEnd);
          }
        }).disableSelection();
        function updateDataList(fromIndex,toIndex){
          let copyDataList=me.comment.slice();
          let d = copyDataList.splice(fromIndex, 1)[0];
          copyDataList.splice(toIndex, 0, d);
          me.comment=copyDataList;
        }
      }
    },
    watch: {
      params: {
        handler: function (val) {
          this.comment = val.comment;
        }
    },
  }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/comment-edit.vue